export { default } from './appendOwnerState';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/appendOwnerState/index.js
// module id = 449
// module chunks = 25